<div class="row">
  <div class="col-md-6">
    <h2><mat-icon>speaker_notes</mat-icon> Letzte Termine</h2>
    <p>für diese vergangenen Termine können Berichte erstellt werden!</p>
    <app-data-table [class]="'table table-striped'" [data]="pendingAppointments" (rowClick)="router.navigate(['appointment', $event.id, 'report'])">
      <colgroup>
        <col class="col-md-1">
        <col class="col-md-6">
        <col class="col-md-2">
      </colgroup>
      <table-column label="Datum">
        <ng-template table-column-content #apointmentRow="content">
          {{ apointmentRow.record.date_time | date: 'shortDate' }}
        </ng-template>
      </table-column>
      <table-column label="Kunde">
        <ng-template table-column-content>
          {{ apointmentRow.record.site.fullName }}
        </ng-template>
      </table-column>
      <table-column label="Ansprechperson">
        <ng-template table-column-content>
          {{ apointmentRow.record.contactPerson?.name }}
        </ng-template>
      </table-column>
      <table-column>
        <ng-template table-column-content>
          <a mat-icon-button [routerLink]="['/appointment', apointmentRow.record.id,'report']">
            <mat-icon>edit</mat-icon>
          </a>
        </ng-template>
      </table-column>

    </app-data-table>

  </div>
  <div class="col-md-6">
    <h2><mat-icon>alarm</mat-icon> Erinnerungen</h2>
    <p>du wolltest an folgende Berichte erinnert werden</p>
    <app-data-table [class]="'table table-striped'" [data]="reminders" (rowClick)="router.navigate(['report', $event.report.id])">
      <colgroup>
        <col class="col-md-4">
        <col class="col-md-5">
        <col class="col-md-2">
        <col class="col-md-1">
      </colgroup>
      <table-column label="Kunde">
        <ng-template table-column-content #reportRow="content">
          {{ reportRow.record.appointment.site.fullName }}
        </ng-template>
      </table-column>
      <table-column label="Betreff">
        <ng-template table-column-content>
          {{ reportRow.record.subject }}
        </ng-template>
      </table-column>
      <table-column label="Erinnerungsdatum">
        <ng-template table-column-content>
          {{ reportRow.record.reminder| date: 'shortDate' }}
        </ng-template>
      </table-column>
      <table-column>
        <ng-template table-column-content>
          <button mat-icon-button (click)="markAsDone($event, reportRow.record)">
            <mat-icon>done</mat-icon>
          </button>
        </ng-template>
      </table-column>
    </app-data-table>
  </div>

</div>



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/dashboard/dashboard.component.html